import { styled } from '@linaria/react';
import { useTranslation } from 'react-i18next';
import { skyLightest } from '../../../../styles/design-tokens';
import { Icon } from '../../../../ui-library/icon/icon';
import { Tooltip } from '../../../../ui-library/tooltip/tooltip';

type Props = {
  onClick: () => void;
};

export const ResetSelectionButton = ({ onClick }: Props) => {
  const i18n = useTranslation();
  return (
    <Tooltip label={i18n.t('process_analysis.main_section.reset_comparison')} variant="white" position="right">
      <Container onClick={onClick}>
        <Icon name="restart_alt" size={20} pointer />
      </Container>
    </Tooltip>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  background-color: ${skyLightest};
  border-radius: 8px;
`;
